<template>
  <b-container class="mt20">
    <b-row>
      <b-col lg="6" xl="6" sm="12" md="6">
        <b-breadcrumb :items="bread"></b-breadcrumb>
      </b-col>

      <b-col lg="6" xl="6" sm="12" md="6">
        <b-input-group style="float: right">
          <b-form-input placeholder="输入关键字搜索" v-model="keyword"></b-form-input>
          <b-input-group-append>
            <b-button variant="info" @click="search">搜索</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-card no-body style="margin-top:10px">
      <b-tabs card content-class="mt-3" lazy>
        <b-tab>
          <template v-slot:title>
            <strong>公告</strong>
          </template>
          <news-list-component ref="notice" type="3" :keyword="keyword"></news-list-component>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <strong>新闻</strong>
          </template>
          <news-list-component ref="news" type="1" :keyword="keyword"></news-list-component>
        </b-tab>
      </b-tabs>
    </b-card>

    <link-component></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '@/components/LinkComponent.vue';
import NewsListComponent from './NewsListComponent';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';

export default {
  components: { LinkComponent, NewsListComponent },
  name: 'news',
  props: {},

  data() {
    return {
      bread: [],
      keyword: ''
    };
  },
  mounted() {},
  activated() {
    // this.reqBody.type = this.$route.query.type | 1;

    this.bread = [
      {
        text: '首页',
        href: '/index'
      }
    ];
    switch (1) {
      case 1:
      case 3:
        this.bread.push({ text: '公告新闻' });
        break;
      case 2:
        this.bread.push({ text: '图片新闻' });
        break;
    }
  },
  methods: {
    search() {
      if (this.$refs.news) {
        this.$refs.news.requestNews(true);
      }
      if (this.$refs.notice) {
        this.$refs.notice.requestNews(true);
      }
    }
  }
};
</script>

<style>
.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border-top: #fff;
  border-left: #fff;
  border-right: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
</style>

<style scoped>
</style>
